export default __webpack_public_path__ + "static/media/loh_quests_trophy.270ab273.svg";